<i
  [className]="!this.isActive ? 'fa infoicon fa-info' : 'fa infoicon fa-close'"
  (click)="this.toggle()"
></i>
